import { useEffect, useRef, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import review1 from '../img/review1.jpg';
import review2 from '../img/review2.jpg';
import review3 from '../img/review3.jpg';

const concerns = [
  {
    objection: '"Worry about the price ?"',
    reality:
      'Not really. We offer competitive price. A neglected pool costs far more in repairs, chemical waste, and equipment damage than regular professional care.',
  },
  {
    objection: '"I don\'t need it yet"',
    reality:
      "Green water, broken pumps, and skin irritation don't wait for a convenient time.",
  },
  {
    objection: '"I\'m not sure I can trust them"',
    reality:
      'Our customers across Bali have trusted us. Read what they say below.',
  },
];

const reviews = [review1, review2, review3];

const PoolCalculatorVideoSection = () => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    AOS.init({ once: false, mirror: true });
  }, []);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 15000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const goTo = (index) => {
    setCurrent(index);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 15000);
  };

  return (
    <section
      id="testimonials"
      className="bg-gray-50 py-20 px-4 sm:px-8 lg:px-20"
    >
      <div className="max-w-5xl mx-auto">
        {/* Section label */}
        <div
          className="text-center mb-10"
          data-aos="fade-up"
          data-aos-duration="700"
        >
          <span className="inline-block text-lg font-semibold tracking-widest text-primary uppercase mb-3">
            Real Customers
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-tertiary mb-4">
            Still Hesitating? You Are Not Alone.
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-lg  leading-relaxed">
            Most pool owners felt the same before working with us. Here is what
            held them back, and what they discovered.
          </p>
        </div>

        {/* Concern cards */}
        <div className="grid sm:grid-cols-3 gap-2 mb-14">
          {concerns.map((c, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl border border-primary/20 p-2 shadow-sm"
              data-aos="fade-up"
              data-aos-duration={`${700 + i * 100}`}
            >
              <p className="text-tertiary font-bold text-lg mb-2">
                {c.objection}
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                {c.reality}
              </p>
            </div>
          ))}
        </div>

        {/* Carousel */}
        <div
          data-aos="fade-up"
          data-aos-duration="800"
          className="flex flex-col items-center"
        >
          <div className="w-full max-w-xl rounded-2xl overflow-hidden shadow-md border border-primary/20 transition-all duration-700">
            <img
              src={reviews[current]}
              alt={`Customer review ${current + 1}`}
              className="w-full h-auto object-contain"
            />
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-5">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                aria-label={`Tampilkan ulasan ${i + 1}`}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  i === current ? 'bg-tertiary scale-125' : 'bg-primary/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PoolCalculatorVideoSection;
